import { useState } from "react";
import { useParams } from "react-router-dom";
import { EndPoints } from "../../../../Constants/endpoints";
import { PrescriptionType } from "../../../../interface/GeneralResponse";
import { useTranslation } from "react-i18next";
import { PrescriptionCard } from "../component";
import { InfiniteScroll, TitleWithArrowLink } from "../../../../components";
import { CardWithIconSkeleton } from "../../../../Share";
import EmptyIcon from "../../../../assets/images/icons/empty-prescription.svg";

function PrescriptionsByMe({ className }: { className?: string }) {
  const { id } = useParams();
  const [prescriptionData, setPrescriptionData] =
    useState<PrescriptionType[]>();

  const { t } = useTranslation();
  return (
    <div
      className={`h-full ${className ? className : "max-h-[58vh]"} overflow-auto`}
    >
      {className ? (
        <TitleWithArrowLink title="prescriptions_by_me" />
      ) : (
        <h1 className="mb-2 text-sm font-semibold">
          {t("prescriptions_by_me")}
        </h1>
      )}

      <div
        className={`grid gap-3 max-lg:grid-cols-2 max-sm:grid-cols-1 xl:grid-cols-2 xxl:grid-cols-3`}
      >
        {(prescriptionData?.length ?? 0) > 0 &&
          prescriptionData?.map((e) => (
            <PrescriptionCard item={e} key={e.Id} isWithImg />
          ))}
        <InfiniteScroll
          Count={20}
          skeletonCount={20}
          endpoint={`${EndPoints.GetPrescriptionToPatient}/${id}`}
          getAllParams={undefined}
          getData={(data) => setPrescriptionData(data)}
          renderSkeleton={<CardWithIconSkeleton />}
          noDataElement={
            <div className="flex h-[34vh] flex-col items-center justify-center gap-4 lg:w-[36%]">
              <img
                alt="empty"
                className="max-w-32 opacity-70"
                src={EmptyIcon}
              />
              <h4 className="text-center text-body-text">{t("no_data_yet")}</h4>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default PrescriptionsByMe;
